import { AnnouncementCard } from './AnnouncementCard';
export default AnnouncementCard;
